<template>
  <div class="footer-floater">
    <div class="header">Competition ends in:</div>
    <Timers :expiresOn="expiresOn" />
  </div>
</template>

<script>
import Timers from "@/components/TimersV2";
import { trackEvent } from "../../analytics";
export default {
  props: ["expiresOn"],
  components: { Timers },
  methods: {
    trackDownloadEvent() {
      trackEvent("clicked to download covve");
    }
  }
};
</script>



<style lang="scss" scoped>
.footer-floater {
  font-size: 0.8rem;
  position: fixed;
  bottom: 0%;
  width: 100%;
  background-color: #3d0046;
  left: 0%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 15px;
}

.header {
  font-size: 14px;
  width: 155px;
  margin-right: 20px;
}

@media (max-width: 768px) {
  .header {
    font-size: 11px;
  }
  .footer-floater {
    font-size: 0.6rem;
  }
}
</style>
